import {
  mapOptions,
  spaceCoordsB1FRaon,
  spaceCoords1FRaon,
  spaceCoords1FAtti,
  spaceCoords2FRaon,
  spaceCoords2FAtti,
  parkingCoordB2F,
  parkingCoordB3F,
} from '@/modules/defines/datas';
import { Space } from '@/modules/defines/interface';
import { Dispatch, SetStateAction } from 'react';
interface UpdateZoneStateProps {
  space?: Space;
  floor?: string;
  setZoneState: Dispatch<SetStateAction<string>>;
  setStandardCoordData: Dispatch<
    SetStateAction<{ zone: string; coord: number[][] }[]>
  >;
}
const updateZoneState = ({
  space,
  floor,
  setZoneState,
  setStandardCoordData,
}: UpdateZoneStateProps) => {
  if (space) {
    if (space.floor === '-1') {
      setZoneState(mapOptions[4].id);
      setStandardCoordData(spaceCoordsB1FRaon);
    } else if (space.floor === '1') {
      if (space.type === 'raon') {
        setZoneState(mapOptions[2].id);
        setStandardCoordData(spaceCoords1FRaon);
      } else if (space.type === 'atti') {
        setZoneState(mapOptions[3].id);
        setStandardCoordData(spaceCoords1FAtti);
      }
    } else if (space.floor === '2') {
      if (space.type === 'raon') {
        setZoneState(mapOptions[0].id);
        setStandardCoordData(spaceCoords2FRaon);
      } else if (space.type === 'atti') {
        setZoneState(mapOptions[1].id);
        setStandardCoordData(spaceCoords2FAtti);
      }
    }
  } else {
    if (floor) {
      if (floor === '-2') {
        setZoneState(mapOptions[5].id);
        setStandardCoordData(
          parkingCoordB2F.map(({ zone, coord, default_pano }) => ({
            zone,
            coord: [coord], // 기존 number[]을 number[][]로 변환
            default_pano,
          }))
        );
      } else if (floor === '-3') {
        setZoneState(mapOptions[6].id);
        setStandardCoordData(
          parkingCoordB3F.map(({ zone, coord, default_pano }) => ({
            zone,
            coord: [coord], // 기존 number[]을 number[][]로 변환
            default_pano,
          }))
        );
      }
    }
  }
};

export default updateZoneState;
